import qs from 'qs';
import IsServerSideRendering from './IsServerSideRendering';

export const removeQueryParam = (paramName = '') => {
  if (IsServerSideRendering) return;

  const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const remainingParams = Object.keys(currentParams).reduce((acc, paramKey) => {
    const isAccountParam = paramKey === paramName;
    return isAccountParam
      ? acc
      : {
        ...acc,
        [paramKey]: currentParams[paramKey]
      };
  }, {});
  const paramString = qs.stringify(remainingParams, { addQueryPrefix: true });
  const relativeUrlWithParamString = window.location.pathname + paramString;
  window.history.replaceState({}, document.title, relativeUrlWithParamString);
};

export default removeQueryParam;
